// Smart Sash Admin Panel - Role Service
// CRUD operations for role management (v2 API)

import { axiosClient } from '../http/axiosClient';
import { RoleDTO } from '@/models';

const BASE_PATH = '/Role';

/**
 * Role Service (v2)
 */
export const roleService = {
  /**
   * Get all roles
   */
  getAll: async (): Promise<RoleDTO[]> => {
    const response = await axiosClient.get<RoleDTO[]>(BASE_PATH);
    return response.data;
  },

  /**
   * Get role by ID
   */
  getById: async (id: string): Promise<RoleDTO> => {
    const response = await axiosClient.get<RoleDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  },

  /**
   * Create new role
   */
  create: async (data: Partial<RoleDTO>): Promise<RoleDTO> => {
    const response = await axiosClient.post<RoleDTO>(BASE_PATH, data);
    return response.data;
  },

  /**
   * Update existing role
   */
  update: async (id: string, data: Partial<RoleDTO>): Promise<RoleDTO> => {
    const response = await axiosClient.put<RoleDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  },

  /**
   * Delete role
   */
  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(`${BASE_PATH}/${id}`);
  },
};

export default roleService;
